// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"7e6c1db9","213":"6b08ee23","453":"c8431e5d","455":"6af1cff6","471":"1fd726b9","566":"eee6192b","748":"53b4ad11"}[chunkId] + ".chunk.js";
};